import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import Classnames from 'classnames';
import { 
    unsubscribeFromAll, 
} from '../../actions/data';
import i18n from '../../i18n';
import './UnsubscribeAll.css';

// Unsubscribe all subscriptions
class UnsubscribeAll extends PureComponent {

    static defaultProps = {
        unsubscribe: false,
        colorGrey: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: this.props.unsubscribe ? true : false,
        };
        
        this.handleClick = this.handleClick.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
    }

    // Confirm and update all the subscriptions
    handleConfirm() {
        this.setState({
            modalOpen: false,
        });

        this.props.unsubscribeFromAll();
    }

    handleClick() {
        this.setState({
            modalOpen: !this.state.modalOpen,
        });
    }

    render() {

        const {
            modalOpen,
        } = this.state;

        const {
            colorGrey,
        } = this.props;

        return (

            <div className='unsubscribe-all'>
                <div className={Classnames('unsubscribe-button', colorGrey ? 'grey-button': '')}>
                   <button
                        onClick={this.handleClick}
                    >
                       {i18n.t('unsubscribe-all')}
                   </button>
                </div>
                { modalOpen ? 
                
                <Modal
                    open={modalOpen === true}
                    showCloseIcon={true}
                    onClose={this.handleClick}
                    focusTrapped={false}
                    classNames={{ overlay: 'modal-overlay', modal: 'unsub-modal' }}
                    closeOnOverlayClick={true}
                    closeOnEsc={true}
                    center>

                    <div className='unsub-modal'>
                        <div className='confirmation-text'>
                            <p>{i18n.t('confirmation-text')}</p>
                        </div>
                            <div className='confirmation-buttons'>
                                <div>
                                    <button onClick={this.handleConfirm}>
                                        {i18n.t('confirm')}
                                    </button>
                                </div>
                                <div>
                                    <button onClick={this.handleClick}>
                                        {i18n.t('cancel')}
                                    </button>
                                </div>
                            </div>
                        </div>

                </Modal>
          : null }
            </div>
        );
    }
}

export default connect(
    null,
    {
        unsubscribeFromAll,
    })(UnsubscribeAll);
